const PAYMENT_METHOD_KEY = 'payment_method';

let rememberedPaymentMethod: string | null = null;

export function rememberPaymentMethod(method: string): void {
  rememberedPaymentMethod = method;

  try {
    sessionStorage.setItem(PAYMENT_METHOD_KEY, method);
  } catch {
    /* ignore */
  }
}

export function readPaymentMethod(): string | null {
  try {
    return rememberedPaymentMethod ?? sessionStorage.getItem(PAYMENT_METHOD_KEY);
  } catch {
    return rememberedPaymentMethod;
  }
}
